module.exports = function () {
  //polyfill localstorage so that it doesn't return a sentry error
  //on supported browsers
  if (typeof localStorage === 'undefined' || !localStorage) {
    window.localStorage = {
      _data: {},
      setItem: function (id, val) {
        return (this._data[id] = val);
      },
      getItem: function (id) {
        return this._data[id];
      },
      removeItem: function (id) {
        return delete this._data[id];
      },
      clear: function () {
        return (this._data = {});
      },
    };
  }
};
